/**
 * @generated SignedSource<<20f26a297bbb7d88f41ca6a435b78f6e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useTradeBenefitsContact_viewer$data = {
  readonly tradeRep: ReadonlyArray<{
    readonly userDataB: ReadonlyArray<{
      readonly displayName: string | null;
      readonly email: string | null;
      readonly firstName: string | null;
      readonly isSystemUser: boolean | null;
      readonly phoneNumber: string | null;
      readonly photoUrl: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "useTradeBenefitsContact_viewer";
};
export type useTradeBenefitsContact_viewer$key = {
  readonly " $data"?: useTradeBenefitsContact_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTradeBenefitsContact_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useTradeBenefitsContact_viewer",
  "selections": [
    {
      "alias": "tradeRep",
      "args": [
        {
          "kind": "Literal",
          "name": "relationshipType",
          "value": "TRADE"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "userIds.0",
              "variableName": "userId"
            }
          ],
          "kind": "ListValue",
          "name": "userIds"
        }
      ],
      "concreteType": "UserRelationship",
      "kind": "LinkedField",
      "name": "userRelationships",
      "plural": true,
      "selections": [
        {
          "alias": "userDataB",
          "args": null,
          "concreteType": "RepData",
          "kind": "LinkedField",
          "name": "userDataBRep",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "photoUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "formatType",
                  "value": "INTERNATIONAL"
                }
              ],
              "kind": "ScalarField",
              "name": "phoneNumber",
              "storageKey": "phoneNumber(formatType:\"INTERNATIONAL\")"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSystemUser",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "db7bdc2f4d6984442497907c90eac1e8";

export default node;
